module.exports = __webpack_public_path__ + "static/directory@2x-51f7eead6d2f50ffd8c53e2aea05801d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/directory@2x.jpg
// module id = 2576
// module chunks = 168707334958949